
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as dashboardoacUt5__ioENBxXmzi6iZD4eyXzr5JLDMsEO0RDvejwMeta } from "/opt/buildhome/repo/src/pages/dashboard.vue?macro=true";
import { default as food_45itemsw3sjB_99LyjLEiC3Yhrvc9gIvG3QbE9zwwovWzOECsIMeta } from "/opt/buildhome/repo/src/pages/food-items.vue?macro=true";
import { default as meals_45pagemHEzwqk8lR5DmXr95nyqJbbN_p94iAjK_Fhh2w_5OCMMeta } from "/opt/buildhome/repo/src/pages/meals-page.vue?macro=true";
import { default as recipes_45page_lI9BoOBZFPPdrIeYXWgXNSqGLSFosmK30_JEjwidQYMeta } from "/opt/buildhome/repo/src/pages/recipes-page.vue?macro=true";
import { default as auth_45callback1cHvOaQ2k472gLNGhrGo6Taz1NHhBRdkKAQ7cQX_qswMeta } from "/opt/buildhome/repo/src/pages/auth-callback.vue?macro=true";
import { default as insights_45pageJ5IN5c7bGrPwtKAprk_U_mRyqzNu0D1_NK5b9LkkICIMeta } from "/opt/buildhome/repo/src/pages/insights-page.vue?macro=true";
import { default as dashboard_0vfxBNblDm_aHY5cVAiap842YWMVSq7779lwbmKya0Meta } from "~/pages/dashboard.vue?macro=true";
import { default as meals_45pagebOnppAtfWmyH499BHi55apaFa20bym3o4w7SBv8KxCUMeta } from "~/pages/meals-page.vue?macro=true";
import { default as recipes_45page7Bj41f8I5gxhdIIykd_DaqeVKWfH4D8GcWp4305FOesMeta } from "~/pages/recipes-page.vue?macro=true";
import { default as auth_45callbacknGsfgix6Rwqxl_1AfYqrwSq2wqHd6CoeSPO_gKiabfQMeta } from "~/pages/auth-callback.vue?macro=true";
import { default as insights_45pagereMJY4xTcc76bq3vQnl_jvgIWV4gwekSZNLkaNW7HpoMeta } from "~/pages/insights-page.vue?macro=true";
export default [
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/opt/buildhome/repo/src/pages/dashboard.vue")
  },
  {
    name: "food-items",
    path: "/food-items",
    component: () => import("/opt/buildhome/repo/src/pages/food-items.vue")
  },
  {
    name: "meals-page",
    path: "/meals-page",
    component: () => import("/opt/buildhome/repo/src/pages/meals-page.vue")
  },
  {
    name: "recipes-page",
    path: "/recipes-page",
    component: () => import("/opt/buildhome/repo/src/pages/recipes-page.vue")
  },
  {
    name: "auth-callback",
    path: "/auth-callback",
    component: () => import("/opt/buildhome/repo/src/pages/auth-callback.vue")
  },
  {
    name: "insights-page",
    path: "/insights-page",
    component: () => import("/opt/buildhome/repo/src/pages/insights-page.vue")
  },
  {
    name: "dashboard",
    path: "/",
    component: () => import("~/pages/dashboard.vue")
  },
  {
    name: "meals",
    path: "/meals",
    component: () => import("~/pages/meals-page.vue")
  },
  {
    name: "recipes",
    path: "/recipes",
    component: () => import("~/pages/recipes-page.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    component: () => import("~/pages/auth-callback.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("~/pages/insights-page.vue")
  }
]